import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.questionHistoryDetail.loading;
export const selectErrorMessage = (state: RootState) =>
  state.questionHistoryDetail.error;
export const questionHistoryDetailResponse = (state: RootState) =>
  state.questionHistoryDetail.questionHistoryDetailResponse;
